import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getBankInformationStart,
  getBankInformationSuccess,
  getBankInformationFailed,
} from "../redux/getBankInformation";

import { getBankInformationApi } from "core/http/service/personnelInformation";
import { resetFormEditBankInformation } from "../redux/formEditBankInformation";

function* getBankInformationWork() {
  try {
    const res = yield call(getBankInformationApi);

    yield put({
      type: getBankInformationSuccess.type,
      payload: res,
    });

    yield put({
      type: resetFormEditBankInformation.type,
    });
  } catch (error: any) {
    yield put({
      type: getBankInformationFailed.type,
    });
  }
}

function* watchGetBankInformation() {
  yield takeLatest(getBankInformationStart.type, getBankInformationWork);
}

export default function* getBankInformationSaga() {
  yield all([watchGetBankInformation()]);
}
